import { BgMaxPrice, ProductUpdate } from '~/Api/User/ProductGroup/BgMaxPrice';

export enum ActionTypes {
	request = 'BgMaxPrice.request',
	receive = 'BgMaxPrice.receive',
	requestUpdate = 'BgMaxPrice.requestUpdate',
	receiveUpdate = 'BgMaxPrice.receiveUpdate',
	scheduleUpdate = 'BgMaxPrice.scheduleUpdate',
	prune = 'BgMaxPrice.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionTypes.request;
}

export interface ReceiveAction {
	groupId: string;
	bgMaxPrice: BgMaxPrice | null;
	request: Promise<any>;
	type: ActionTypes.receive;
}

export interface ScheduleUpdateAction {
	basketVersion: string;
	groupId: string;
	packageSize: number | null;
	products: ProductUpdate[];
	historicProductDataViewDate: Date | null;
	timeoutId: NodeJS.Timeout;
	type: ActionTypes.scheduleUpdate;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionTypes.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	bgMaxPrice: BgMaxPrice | null;
	request: Promise<any>;
	type: ActionTypes.receiveUpdate;
}

export interface PruneAction {
	groupId: string;
	type: ActionTypes.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| PruneAction;
